var React = require('react');

function Adventure (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"nonzero"},[React.createElement("path",{"d":"M15.5 0C6.94 0 0 6.94 0 15.5 0 24.06 6.94 31 15.5 31 24.06 31 31 24.06 31 15.5 31 6.94 24.06 0 15.5 0zm0 28.786c-7.337 0-13.286-5.949-13.286-13.286S8.163 2.214 15.5 2.214 28.786 8.163 28.786 15.5 22.837 28.786 15.5 28.786z","key":0}),React.createElement("path",{"d":"M6.889 24.11s9.785-3.524 11.742-5.479c1.957-1.957 5.48-11.742 5.48-11.742s-9.786 3.524-11.742 5.48c-1.956 1.956-5.48 11.741-5.48 11.741zm7.045-10.175l3.132 3.13c.782.783-7.045 3.914-7.045 3.914s3.13-7.827 3.913-7.044z","key":1})]));
}

Adventure.defaultProps = {"width":"31","height":"31"};

module.exports = Adventure;

Adventure.default = Adventure;
